import React, { useEffect, useState } from 'react';
import { EmployerLayout } from '../Layout/EmployerLayout'
import classes from './EmployerHome.module.css'
import NavCard from '../Components/NavCard/NavCard';
import HomeChart from '../Components/HomeChart/HomeChart';
import HomePackage from '../Components/HomePackage/HomePackage';
import Skeleton, { SkeletonTheme } from 'react-loading-skeleton'
import 'react-loading-skeleton/dist/skeleton.css'
import WelcomeName from '../Components/WelcomeName/WelcomeName';
import { IRootState } from '../../../State/Store';
import { useSelector } from 'react-redux';
import { authAxios } from '../../../API/apiRequest';
import ReactGA from 'react-ga'
const EmployerHome: React.FC<any> = (props)=>{    

    const [loading, setLoading] = useState(true)
    const [plan, setPlan] = useState(null)
    const [dates, setDates] = useState<string[] | []>([])
    const [applications, setApplications] = useState<[{id: string, title: string, data: number[]}] | []>([])
    const [seen, setSeen] = useState<[{id: string, title: string, data: number[]}] | []>([])
    const [name, setName] = useState('')
    const user = useSelector((state: IRootState)=>state.user)
    useEffect(()=>{
      if(user.name)
          setName(user.name.split(' ')[0])
           
      async function getHome(){
          try{
            const result = await authAxios.get('/employer/home')
            setPlan(result.data.plan)
            setApplications(result.data.applications)
            setSeen(result.data.seen)
            setDates(result.data.dates)
          }catch(e){

          }
          setLoading(false)
        }
        getHome()
        ReactGA.pageview(window.location.pathname)
    },[user.name])

    if(loading) return <HomeLoading />
    else
    return(
       <EmployerLayout>
            <WelcomeName name={name} />
            <div className='row mx-0 justify-content-center'>
              <div className='col-md px-0'>
                <HomePackage 
                  plan={plan}
                />
              </div>
            </div>
            <div className="row mx-0 mt-3 justify-content-center">
                <div className={'col-md'} style={{marginTop: 10}}>
                   <NavCard 
                    title='إدارة الوظائف'
                    iconName='FiSettings'
                    to='/employer/jobs'
                   />
                </div>
                <div className={'col-md'} style={{marginTop: 10}}>
                  <NavCard 
                    title='إضافة وظيفة'
                    iconName='FiSend'
                    to='/employer/addjob'
                   />
                </div>
            </div>
            <div className='col'>
                <h3 className={classes.ptitle}>إحصائيات</h3>
            </div>
            <HomeChart series={seen} dates={dates} title={'مشاهدات آخر ثلاثة وظائف'}/>
            <HomeChart series={applications} dates={dates} title={'تقديمات آخر ثلاثة وظائف'}/>
       </EmployerLayout>
    )
}


const HomeLoading: React.FC = ()=>{

    return(
        <EmployerLayout>
           <SkeletonTheme baseColor="gray" highlightColor="#fff">
            <div className='col'>
               <p style={{textAlign: 'right'}}><Skeleton width={160} direction='rtl' duration={0.8} /></p>
            </div>
            <div className='row mx-0 justify-content-center'>
              <div className='col-md'>
                <div className='col-md justify-content-center m-auto'>
                    <p><Skeleton direction='rtl' height={40} duration={0.8} /></p>
                 </div> 
              </div>
              </div>
            <div className="row mx-0 justify-content-center">
                <div className={'col-md'} style={{marginTop: 10}}>
                <p><Skeleton direction='rtl' height={65} duration={0.8} /></p>
                   
                </div>
                <div className={'col-md'} style={{marginTop: 10}}>
                <p><Skeleton direction='rtl' height={65} duration={0.8} /></p>
                </div>
            </div>
            <div className='col'>
                <p style={{textAlign: 'right'}}><Skeleton width={150} direction='rtl' duration={0.8} /></p>
            </div>
            <div className='col-md justify-content-center m-auto'>
             <p><Skeleton direction='rtl' height={100} duration={0.8} /></p>
             <p><Skeleton direction='rtl' height={100} duration={0.8} /></p>
            </div>
          </SkeletonTheme>
       </EmployerLayout>
    )
}






export default EmployerHome